"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _coreInteractiveIcon = _interopRequireDefault(require("@vfuk/core-interactive-icon"));
var _coreBaseProps = require("@vfuk/core-base-props");
var _reactI18next = require("react-i18next");
var Styled = _interopRequireWildcard(require("./styles/CloseButton.style"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var CloseButton = function CloseButton(_ref) {
  var srName = _ref.srName,
    onClick = _ref.onClick,
    inverse = _ref.inverse,
    _ref$isWithinHeader = _ref.isWithinHeader,
    isWithinHeader = _ref$isWithinHeader === void 0 ? false : _ref$isWithinHeader,
    dataSelectorPrefix = _ref.dataSelectorPrefix;
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement(Styled.CloseButton, {
    isWithinHeader: isWithinHeader
  }, /*#__PURE__*/_react["default"].createElement(_coreInteractiveIcon["default"], {
    name: "close",
    srText: "".concat(t('Close'), " ").concat(srName),
    inverse: inverse,
    onClick: onClick,
    size: 5,
    isResponsive: false,
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix)
  }));
};
CloseButton.displayName = "CloseButton";
var _default = /*#__PURE__*/(0, _react.memo)(CloseButton);
exports["default"] = _default;